import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  Game,
  GameUser, GameVolleyballPositionLocalization,
  VolleyballGameStatistic
} from '@mtgame/core';

@Component({
  selector: 'mtg-volleyball-game-mvp-users',
  templateUrl: './volleyball-game-mvp-users.component.html',
  styleUrls: ['./volleyball-game-mvp-users.component.scss', '../../game/styles/mvp-users.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VolleyballGameMvpUsersComponent implements OnChanges {
  @Input()
  mvpUsers: GameUser[];
  @Input()
  game: Game;
  @Input()
  statistic: VolleyballGameStatistic[];
  userStatistic: {[key: number]: VolleyballGameStatistic} = {};
  positionLocalization = GameVolleyballPositionLocalization;
  teamMvpUsers: GameUser[];
  competitorTeamMvpUsers: GameUser[];

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.mvpUsers || changes.game) && this.game && this.mvpUsers) {
      this.teamMvpUsers = this.mvpUsers.filter(item => item.teamUser.teamId === this.game.team.id);
      this.competitorTeamMvpUsers = this.mvpUsers.filter(item => item.teamUser.teamId === this.game.competitorTeam.id);
    }
    if (changes.statistic && this.statistic) {
      this.userStatistic = this.statistic.reduce((acc, item) => ({
        ...acc,
        [item.gameUserId]: item,
      }), {});
    }
  }

  getUserStatistic(user: GameUser): {title: string, value: number}[] {
    const userStatistic = this.userStatistic[user.id] || new VolleyballGameStatistic();
    return [
      {title: 'очки', value: userStatistic.points},
      {title: 'эйсы', value: userStatistic.serveAces},
      {title: 'блоки', value: userStatistic.stuffBlocks},
      {title: 'атаки', value: userStatistic.attackSpikes},
      {title: 'отл. приемы', value: userStatistic.excellentReceives + userStatistic.excellentServeReceives},
    ].sort((a, b) => b.value - a.value).slice(0, 3);
  }
}
